import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface EventDateProps {
  date: Date;
}

const dateMonthFormatter = new Intl.DateTimeFormat("fr-ca", {
  day: "numeric",
  month: "short",
});

export function EventDate({ date }: EventDateProps) {
  const day = dateMonthFormatter
    .formatToParts(date)
    .find((part) => part.type === "day");

  const month = dateMonthFormatter
    .formatToParts(date)
    .find((part) => part.type === "month");

  return (
    <div className="relative flex items-center gap-3 md:block">
      <FontAwesomeIcon
        className="text-[rgba(1,139,22,0.8)] md:hidden"
        icon={faCalendar}
        size="2x"
      />
      <FontAwesomeIcon
        className="hidden text-[rgba(1,139,22,0.8)] md:block"
        icon={faCalendar}
        size="4x"
      />
      <div className="text-sm font-bold uppercase text-[rgba(1,139,22,0.8)] md:absolute md:top-0 md:left-0 md:bottom-0 md:flex md:w-full md:flex-col md:items-center md:justify-center md:pt-6 md:text-center md:text-white">
        <span className="md:hidden">{day?.value} {month?.value}</span>
        <span className="hidden md:block">
          {day?.value}
          <br />
          {month?.value}
        </span>
      </div>
    </div>
  );
}
